import {post, get} from "../util/crmAxios";// 新的post地址
import {getBasicUrls}  from "../util/config";
const baseUrl = getBasicUrls().reportUrl
const streetUrl = getBasicUrls().schoolm
const crmBaseUrl = getBasicUrls().crm
const schoolCrm = getBasicUrls().schoolCrm

// 校区详情  用户信息
// export const searchSchoolList = (params) => post('/manage/search/searchSchoolList', params)
export const searchSchoolList = (params) => post(`${streetUrl}manage/search/searchSchoolList`, params)
//校区信息快捷查询post
export const searchBaseSchoolList = (params) => post('/manage/search/searchBaseSchoolList', params)
//查询签约主体
export const querySignMain = (params) => post(`${schoolCrm}manage/schoolinfo/querySignMain`, params)
//根据schoolId获取退费信息
export const getSchoolRefundInfoBySchoolId = (params) => get(schoolCrm + '/manage/refund/getSchoolRefundInfoBySchoolId', params)
//新增编辑退费信息
export const operateRefundInfo = (params) => post('/manage/refund/operateRefundInfo', params)
//删除退款明细
export const deleteRefundDetailById = (params) => get('/manage/refund/deleteRefundDetailById', params)
// 返还单列表查询
export const getReturnOrderList = (params) => post('manage/returnOrder/getReturnOrderList',params)
// 返还账号列表
export const queryReturnAccountList = (params) => post('manage/returnOrder/queryReturnAccountList',params)
// 处理返还单信息
export const opReturnOrder = (params) => post('manage/returnOrder/opReturnOrder',params)
// 新增或更新返还账号
export const addOrUpdateReturnAccount = (params) => post('manage/returnOrder/addOrUpdateReturnAccount',params)
// 批量处理返还单信息
export const batchOpReturnOrder = (params) => post('manage/returnOrder/batchOpReturnOrder',params)
// 获取返还单详情
export const getReturnOrderInfo = (params) => get('manage/returnOrder/getReturnOrderInfo',params)

export const loadData = params => post(`${baseUrl}report/data/loadData`, params)
// 查询接受验证码的手机号
export const getCheckPhoneNo = params => get(`${schoolCrm}manage/schoolinfoother/getCheckPhoneNo`, params)
// 设置校区状态
export const setSchoolStatus = params => post(`manage/schoolinfoother/setSchoolStatus`, params)

// 统计分析列表(传schooldIds查询统计的关联校区)
export const queryStatisticsPage = params => post(`${schoolCrm}manage/statisticalAnalysis/queryStatisticsPage`, params)
// 统计分析列表(传schooldIds查询统计的关联校区)
export const getAppConfig = params => get(`${crmBaseUrl}base/sysconfig/getAppConfig?keyName=batch_import_agent_template`, params)


// 新增学校信息(不包括关联校)
export const saveBaseSchool = params => post(`${schoolCrm}manage/statisticalAnalysis/saveBaseSchool`, params)
// 编辑学校信息()
export const updateBaseSchool = params => post(`${schoolCrm}manage/statisticalAnalysis/updateBaseSchool`, params)
// 基于id或者名字查询多个合作校信息
export const findHandoverName = params => get(`${schoolCrm}manage/statisticalAnalysis/findHandoverName`, params)
// 绑定学校和关系校数据
export const bindSchool = params => post(`${schoolCrm}manage/statisticalAnalysis/bindSchool`, params)
// 移除学校信息
export const deleteBaseSchool = params => post(`${schoolCrm}manage/statisticalAnalysis/deleteBaseSchool`, params)
// 移除学校信息
export const searchDisRules = params => post(`alloter/rule/searchDisRules`, params)

// 获取分配规则
export const getRuleInfo = params => get(`alloter/rule/getRuleInfo`, params)

// 添加分配规则
export const addModifyAlloterRule = params => post(`alloter/rule/addModifyAlloterRule`, params)

// 校区查询
export const queryCampusList = params => get(`alloter/rule/queryCampusList`, params)
// 校区查询
export const modifyRuleStatus = params => post(`alloter/rule/modifyRuleStatus`, params)
// 查询省市区信息
export const queryCityList = (params) => get(`manage/searchCity/queryCityList`, params)
// 查询学校
export const querySchoolList = (params) => get(`manage/searchCity/querySchoolList`, params)
// 获取分配来源的信息
export const querySourceList = (params) => get(`alloter/rule/querySourceList`, params)
// 获取已开启标签信息
export const getEnableClueTagConfig = (params) => get(`crm/rule/getEnableClueTagConfig`, params)

// 清空退费数据
export const flushRefund = (params) => post(`manage/refund/flushRefund`, params)
